<template>
  <omint-page>
    <Header name="Busca de rede" titleLabel="Busca de rede" />
    <omint-slider>
      <router-view />
    </omint-slider>
    <Footer />
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "Network-search",
  components: {
    Header,
    Footer
  }
};
</script>
